import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import {
  TopBarFullCtaColors,
  TopBarFullUseCaseEnums,
  TopBarFullImagePositions,
} from '../TopBarFullEnums';
import UCCustomerSatisfaction from './imageComponents/UcCustomerSatisfactionImage';

const DEFAULT_UTSOURCE2 = 'full_initiate_upsell_customer_satisfaction';
const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.headline',
    defaultMessage: 'Brand your customer surveys',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.message',
    defaultMessage:
      'Get fancy. Customize surveys with your logo and colors plus a white label URL.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.ctaText',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const INITIATED_DRAFTED_UTSOURCE2 =
  'full_initiate_upsell_customer_satisfaction';
const INITIATED_DRAFTED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.headlineInitiated',
    defaultMessage: 'Brand your customer surveys',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.messageInitiated',
    defaultMessage:
      'Get fancy. Customize surveys with your logo and colors plus a white label URL.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.ctaTextInitiated',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const TESTED_ACTIVATED_UTSOURCE2 = 'full_activate_upsell_customer_satisfaction';
const TESTED_ACTIVATED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.headlineTested',
    defaultMessage: 'Make it yours with a custom email invitation',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.messageTested',
    defaultMessage:
      'Give your surveys a personal touch. Add custom designs, images, videos, or hyperlinks.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.ctaTextTested',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const DEPLOYED_UTSOURCE2 = 'full_deploy_upsell_customer_satisfaction';
const DEPLOYED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.headlineDeployed',
    defaultMessage: 'Add a custom thank-you to customers',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.messageDeployed',
    defaultMessage:
      'Show your appreciation with a special note and bring respondents to your website.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseCustomerSatisfactionTopBarFull.ctaTextDeployed',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type UseCaseCustomerSatisfactionTopBarFullProps = {
  variation?: TopBarFullUseCaseEnums | null;
};

const VariationToCopy = {
  [TopBarFullUseCaseEnums.InitiatedDrafted]: {
    copy: INITIATED_DRAFTED_COPY,
    utSource2: INITIATED_DRAFTED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.TestedActivated]: {
    copy: TESTED_ACTIVATED_COPY,
    utSource2: TESTED_ACTIVATED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.Deployed]: {
    copy: DEPLOYED_COPY,
    utSource2: DEPLOYED_UTSOURCE2,
  },
};

export const UseCaseCustomerSatisfactionTopBarFull: React.FC<UseCaseCustomerSatisfactionTopBarFullProps> = ({
  variation, //TODO: get this data.
}) => {
  const [copy, utSource2] =
    variation && variation in VariationToCopy
      ? [VariationToCopy[variation].copy, VariationToCopy[variation].utSource2]
      : [DEFAULT_COPY, DEFAULT_UTSOURCE2];

  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <UCCustomerSatisfaction />}
      imagePosition={TopBarFullImagePositions.low}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL(`/pricing/upgrade`, {
        ut_source: 'topbar',
        ut_source2: utSource2,
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCaseCustomerSatisfactionTopBarFull;
